import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';

@Component({
  selector: 'app-requisition-action-modal',
  templateUrl: './requisition-action-modal.component.html'
})
export class RequisitionActionModalComponent implements OnInit {
  @ViewChild('actionform') actionform: NgForm;

  modalData: any;
  public onClose: Subject<any>;
  MESSAGECONSTANTS = MESSAGECONSTANTS;
  isDeleteInProgress = false;
  copyNote: any;

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
  }

  closeModal() {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

  onModifyRequisitionStates(direction) {
    const requisitionSPOC = this.modalData.requisitionSPOC;
    if (requisitionSPOC.currentStateName !== 'Delete' && requisitionSPOC.currentStateName !== 'Copy') {
      this.bsModalRef.hide();
      this.modalData.modifyRequisitionStates(requisitionSPOC, direction);
    } else if (requisitionSPOC.currentStateName === 'Copy') {
      this.modalData.copyRequisition(requisitionSPOC, () => {
        this.onClose.next(true);
        this.bsModalRef.hide();
      });
    } else {
      this.isDeleteInProgress = true;
      this.modalData.deleteRequisition(requisitionSPOC, () => {
        this.onClose.next(true);
        this.bsModalRef.hide();
      });
    }
  }

  onInternalNoteChanged() {
    this.modalData.requisitionSPOC.externalNote = this.modalData.requisitionSPOC.note;
  }

  onExternalNoteChange(event) {
    this.modalData.requisitionSPOC.externalNote = event.externalNote;
  }

  onCopyNoteChange(event) {
    this.copyNote = event.copyNote;
  }

  receiveFormalizedComment(event) {
    this.modalData.requisitionSPOC.note = event;
  }

  onVoiceTranscript(transcript) {
    if (this.modalData.requisitionSPOC.note) {
      this.modalData.requisitionSPOC.note += ' ' + transcript;
    } else {
      this.modalData.requisitionSPOC.note = transcript;
    }
  }

}
